import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-pending',
  templateUrl: './fh-svg-pending.component.html',
  styleUrl: './fh-svg-pending.component.scss'
})
export class FhSvgPendingComponent {
  @Input() color: string = '';
}
